export const API_OPENED_PLUGINS = '/plugin/ajax-list-plugin-nav'
export const getOpenedPluginsAPI = (siteId: string) => `${API_OPENED_PLUGINS}?site_id=${siteId}`